<template>
  <div class="card card-body rounded-top">
    <liquor-tree ref="tree" :data="tree" :options="options" :key="componentKey">
      <span style="width:100%" class="tree-text tree-item" slot-scope="{ node }">
        <span class="tree-item__first-element" :class="{ 'font-weight-bold': node.data.isAssigned }">
          {{ `${node.text} ${node.data.isAssigned ? '(posiadana)' : ''}` }}
        </span>

        <span v-if="adminRoleId === node.id">
          <check-permission entityType="profile" permissions="USER.ROLE_MANAGE" :entityId="$route.params.profileId">
            <button
              v-if="node.data.isAssigned"
              class="btn btn-lg btn-icon rounded-circle hover-effect-dot waves-effect waves-themed mr-2 btn-delete"
              @click.stop="showDeleteDialog(node.id)"
            >
              <i :style="{ color: DELETE_ACTION.color }" :class="DELETE_ACTION.icon" />
            </button>

            <button
              v-else
              class="btn btn-lg btn-icon rounded-circle hover-effect-dot waves-effect waves-themed mr-2 btn-add"
              @click.stop="showAddDialog(node.id)"
            >
              <i :style="{ color: ADD_ACTION.color }" :class="ADD_ACTION.icon" />
            </button>
          </check-permission>
        </span>
      </span>
    </liquor-tree>
  </div>
</template>
<script>
import LiquorTree from 'liquor-tree';
import { mapState } from 'vuex';

import { DELETE_ACTION, ADD_ACTION } from '@/utils/constants';
import { buildTree } from '@/utils/tree';

// @vuese
// Lista ról użytkownika
// @group Profile
export default {
  components: {
    LiquorTree
  },
  data() {
    return {
      options: {
        checkbox: false,
        propertyNames: {
          text: 'name'
        }
      },
      DELETE_ACTION,
      ADD_ACTION,
      componentKey: 0
    };
  },
  computed: {
    ...mapState({
      tree(state) {
        const userRoles = state.profile.roles.list;

        const roles = state.role.list.map(role => ({
          ...role,
          data: {
            isAssigned: userRoles.some(userRole => userRole.id === role.id)
          },
          state: { expanded: true, selectable: false }
        }));
        return buildTree(roles);
      },
      adminRoleId: state => state.setting.list[0].id
    })
  },
  methods: {
    // @vuese
    // Pokazuje dialog potwierdzający usunięcie roli
    showDeleteDialog(roleId) {
      this.$store.dispatch('showConfirm', {
        title: this.$t('text.delete-dialog-title'),
        description: this.$t('text.profile-list.revoke-role'),
        onSuccess: () => this.remove(roleId)
      });
    },
    // @vuese
    // Pokazuje dialog potwierdzający dodanie roli
    showAddDialog(roleId) {
      this.$store.dispatch('showConfirm', {
        title: this.$t('text.add-dialog-title'),
        description: this.$t('text.profile-list.grant-role'),
        onSuccess: () => this.add(roleId)
      });
    },
    // @vuese
    // Usuwa rolę użytkownikowi
    remove(roleId) {
      this.$store.dispatch('profile/roles/remove', roleId);
    },
    // @vuese
    // Dodaje rolę do użytkownika
    add(roleId) {
      this.$store.dispatch('profile/roles/add', roleId);
    },
    // @vuese
    // Odświeża drzewo
    forceUpdate() {
      this.componentKey++;
    }
  },
  watch: {
    '$store.state.profile.roles.list'(val) {
      this.forceUpdate();
    }
  }
};
</script>

<style>
.tree-item {
  display: flex;
  align-items: center;
  justify-content: center;
}

.tree-item__first-element {
  flex: 1;
}
</style>
